import { z } from 'zod';
import { MAX_DAILY_SELL_LIMIT, MIN_DAILY_SELL_LIMIT } from '../constants';

export const fieldNames = {
    absolutePerTimeUnitLimit: 'absolutePerTimeUnitLimit',
} as const;

export const validationSchema = z.object({
    [fieldNames.absolutePerTimeUnitLimit]: z
        .number()
        .int()
        .min(MIN_DAILY_SELL_LIMIT)
        .max(MAX_DAILY_SELL_LIMIT)
        .default(MIN_DAILY_SELL_LIMIT),
});

export type FormValues = z.infer<typeof validationSchema>;
